import { useTranslate } from "ra-core";

import { MobilePage } from "../layout/MobilePage";
import { SettingsPage } from "./SettingsPage";

/**
 * The stages editor on a phone: the desktop <SettingsPage> form wrapped in a
 * mobile page with a back button to the settings hub. Reached from the
 * "Fasen" link on /settings; the hub itself lives in <SettingsPageMobile>.
 */
export const SettingsFasenMobile = () => {
  const translate = useTranslate();
  return (
    <MobilePage
      title={translate("crm.settings.sponsorings.stages")}
      backTo="/settings"
    >
      <SettingsPage />
    </MobilePage>
  );
};

SettingsFasenMobile.path = "/settings/fasen";
